import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { AuthService } from 'src/app/air/modules/common/service/auth/auth.service';
import { AirAppRoutes } from "src/app/air/modules/common/lib/air-api-constant";
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { StorageService } from 'src/app/air/modules/common/service/storage/storage.service';
import { CommonService } from 'src/app/air/modules/common/service/common/common.service';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-password-confirm',
    templateUrl: './password-confirm.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class PasswordConfirmComponent {
  private subscription = new SubSink();
  timeLeft: number;
  interval;
  timerVisibility: boolean;
  resetPasswordLink: any;
  constructor(private authService: AuthService,
    private messageService: MessageService,
    private commonService: CommonService,
    private storageService: StorageService) {
    this.resetPasswordLink = [this.commonService.getRoute({ route: AirAppRoutes.Auth.RESET_PASSWORD })];
  }

  ngOnInit(): void {
    this.startTimer();
  }

  resendCode() {
    // this.subscription.unsubscribe();
    // let email = this.storageService.getItem('userEmail');
    // this.pauseTimer();
    // this.authService.resendLink({ email: email }).then((data: any) => {
    //   if (data) {
    //     this.messageService.add({
    //       key: 'emptyToster',
    //       severity: 'success',
    //       life: 10000,
    //       summary: 'Success Message',
    //       detail: "Check Inbox, Email Sent !"
    //     });
    //     this.startTimer();
    //     return;
    //   }
    // }).catch((err) => {
    //   this.messageService.add({
    //     key: 'emptyToster',
    //     severity: 'error',
    //     life: 10000,
    //     summary: 'error Message',
    //     detail: err.message
    //   });
    //   return;
    // })
    //#region observable
    // this.subscription.add(this.authService.resendLink({ email: this.storageService.getItem('userEmail') }).subscribe((data: any) => {
    //   if (data.status == 200) {
    //     this.authService.passwordResendNav();
    //   }
    // }));
    //#endregion observable
  }
  pauseTimer() {
    clearInterval(this.interval);
  }
  startTimer() {
    this.timeLeft = 30;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timerVisibility = true;
        this.timeLeft--;
      }
      else {
        this.timerVisibility = false;
      }
    }, 1000)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
